import { nanoid } from 'nanoid';
import { nanoid as nonSecureId } from 'nanoid/non-secure';

/**
 * Generates a URL-friendly, unique string ID
 * Example: "V1StGXR8_Z5jdHi6B-myT"
 *
 * @param size Size of the ID. The default size is 21.
 * @returns A random string.
 */
export const generateId = (size?: number) => {
  let id;
  try {
    id = nanoid(size);
  } catch {
    // fallback when browser does not support crypto web API https://github.com/ai/nanoid/blob/master/index.browser.js#L22
    id = nonSecureId(size);
  }

  return id;
};
